// extracted by mini-css-extract-plugin
export default {"head":"goBack_head__KvGo3","arrow":"goBack_arrow__x9kKb","back":"goBack_back__prlo4"};